import { createAsyncThunk } from '@reduxjs/toolkit';
import { RejectValue } from './Types.ts';
import { RootState } from '../Store/store.ts';
import { FitAssistantOptionsResponse } from '../Types/FitAssistantGraphQLTypes.ts';
import { getSearchParametersFromQuery } from '../Util/QueryFromParameters.ts';
import { applyLoadedCarOptions, loadOptionsFromCookie } from './LoadOptionsFromCookie.ts';
import { Constants } from '../Constants.ts';

type SolutionIdOptionsResponse = {
  Options: FitAssistantOptionsResponse[];
  SolutionId: string | null;
};

export const loadOptionsFromSolutionId = createAsyncThunk<string, void, RejectValue>(
  'fitAssistant/loadOptionsFromSolutionId',
  async (_, { getState, dispatch, fulfillWithValue, rejectWithValue }) => {
    const state = getState() as RootState;
    const initialData = state.FitAssistant.initialData;
    const solutionVehicleId = getSearchParametersFromQuery(Constants.QueryParameters.SOLUTION_ID);

    const url = new URL(window.location.href);
    url.searchParams.delete(Constants.QueryParameters.SOLUTION_ID);
    history.replaceState(null, '', url.toString());

    const response: SolutionIdOptionsResponse | null = await fetch('/api/sitecore/fitguide/LoadOptionsFromSolutionId', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        solutionVehicleId,
        steps: initialData.Steps.filter((x) => !x.SkipWhenLoadingFromCookie),
        additionalFilter: initialData.AdditionalFilters ? JSON.stringify(initialData.AdditionalFilters) : null,
      }),
    })
      .then((res): Promise<SolutionIdOptionsResponse> => res.json())
      .catch((): null => null);

    if (!response?.Options?.length) {
      await dispatch(loadOptionsFromCookie());
      return fulfillWithValue('No car found for solution id, loaded options from cookie instead');
    }

    const error = await applyLoadedCarOptions(
      response.Options,
      { isNewSelection: true, preferredSolutionId: response.SolutionId },
      state,
      dispatch
    );
    if (error) return rejectWithValue(error);

    return fulfillWithValue('Loading options from solution id finished');
  }
);
